import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app';
import { AuthProvider } from './auth_context';
import { RoleProvider } from './role_context';
import { BrowserRouter } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import {
  SESSION_KEYS,
  setSessionValue,
} from "./utils/browser_storage_helpers";
import { logger } from './utils/logger';
import { HelmetProvider } from "react-helmet-async";
import { captureEntryCandidateInvite } from "./utils/entry_candidate_invite";
import { captureSponsorVerificationInvite } from "./utils/sponsor_verification_invite";
import { captureVendorVerificationInvite } from "./utils/vendor_verification_invite";

// Capture bearer credentials before any rendered surface can initialize analytics.
// The helper strips the private fragment and keeps only in-memory scoped access.
captureEntryCandidateInvite();
captureSponsorVerificationInvite();
captureVendorVerificationInvite();

// ✅ Store CID from URL if present BEFORE app renders
// ✅ Store pending vote CID from URL if present BEFORE app renders
// ✅ Uses centralized session helper instead of direct localStorage
const urlParams = new URLSearchParams(window.location.search);
const cid = urlParams.get("cid");

if (cid) {
  logger.log("💾 Storing pending vote CID in session storage helper:", {
    value: cid,
  });

  setSessionValue(SESSION_KEYS.PENDING_VOTE_CID, cid);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <RoleProvider>
            <App />
          </RoleProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
